<template>
  <div id="app" class="bg-light">
    <b-navbar class="border-bottom bg-white" toggleable="lg" type="light">
      <b-navbar-brand to="/"
        ><img src="https://cardxcoin.com/dist/images/logo-dark.svg"
      /></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/dashboard">Dashboard</b-nav-item>
          <b-nav-item to="/deposit">Deposit</b-nav-item>
          <b-nav-item to="/challenge">Challenge</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav type="dark" class="ml-auto">
          <b-nav-item>
            <div class="menuitem">
              <wallet-connector></wallet-connector>
            </div>
          </b-nav-item>
          <b-nav-item>
            <div class="menuitem">
              <b-dropdown variant="link" class="text-white" no-caret>
                <template #button-content>
                  <span>
                    <b-icon icon="three-dots-vertical" variant="dark" aria-label="More"></b-icon>
                  </span>
                </template>
                <b-dropdown-item>More</b-dropdown-item>
              </b-dropdown>
            </div>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <br>
    <div class="container">
      <transition name="slide">
        <router-view></router-view>
      </transition>
    </div>
    <br>
    <br>
    <!-- <div>
      <b-nav class="mt-4 mb-2" align="center">
        <b-nav-item active>Active</b-nav-item>
        <b-nav-item>Link</b-nav-item>
        <b-nav-item>Another Link</b-nav-item>
        <b-nav-item disabled>Disabled</b-nav-item>
      </b-nav>
    </div> -->
  </div>
</template>
<script>
import WalletConnector from './components/WalletConnector.vue'
export default {
  components: {
    WalletConnector
  },
  mounted() {
    this.$store.dispatch('ethereum/init')
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;  
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
}
/* .menuitem {
  border-left: solid 1px;
}
.menuitem button {
  margin-left: 10px
} */
</style>
